import { type Meta } from '../types/docs';
import { AGENT_ONBOARDING_AUDIENCE_META_PARAM, AGENT_ONBOARDING_TIME_SINK_IDS } from './agentOnboardingAnalytics';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'The reveal finishes and the agent panel docks',
  name: 'agent_onboarding_completed',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    AGENT_ONBOARDING_AUDIENCE_META_PARAM,
    {
      description: 'The winning time sink whose demo just finished',
      name: 'outcome',
      required: true,
      type: 'enum',
      values: [...AGENT_ONBOARDING_TIME_SINK_IDS],
    },
  ],
};

export default META;
